import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
export function ProductPresentation() {
  return <section className="py-20 bg-tennis-green text-white relative overflow-hidden" data-id="element-249">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#fff 2px, transparent 2px)',
      backgroundSize: '30px 30px'
    }} data-id="element-250"></div>

      <div className="max-w-5xl mx-auto px-4 relative z-10 text-center" data-id="element-251">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-252">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-5 py-2 text-sm font-bold tracking-wider text-ball-yellow mb-6 uppercase" data-id="element-253">
            <span data-id="element-254">🏆</span> El Sistema N°1 para Profesores de Tenis Argentinos
          </div>

          <h2 className="text-4xl md:text-5xl lg:text-6xl font-display leading-tight mb-10" data-id="element-255">
            TENIS 360 — Colección Completa
            <br data-id="element-256" />
            <span className="text-clay-orange" data-id="element-257">
              12 Tomos + 6 Bonus + 2 Elite
            </span>
            <br data-id="element-258" />
            Todo resuelto, todos los niveles.
          </h2>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-259">
            {['+280 páginas', '+150 ejercicios graficados', 'Todos los niveles', '100% Argentina'].map((stat, i) => <div key={i} className="flex items-center gap-2 text-lg font-medium bg-white/5 px-4 py-2 rounded-lg border border-white/10" data-id="element-260">
                <CheckCircle2Icon className="text-ball-yellow" size={20} data-id="element-261" />
                <span data-id="element-262">{stat}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}